<div class="page-content container">
  <div class="page-header">
    <h1>
      {{ translationManager.getTranslation('Чланови тима укључени у оцењивање понуда') }}
    </h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info">
        <span><i class="fa fa-info-circle"></i>
          {{ translationManager.getTranslation('Страница за приказ чланова тима који учествују у оцењивању понуда') }}
        </span>
      </div>
      <div class="page-part">
        <br>
        <span><b>{{ translationManager.getTranslation('Рок за усаглашавање ОПН-а') }} :
            {{deadlineForCompletion | appdate | appvalue}}</b></span>
      </div>
    </div>
    <div class="page-part" *ngIf="
        state === viewState.Edit && auth.isAuthorized('F6DD18CB-A195-4107-BE7E-CADE04DC7E3D') &&
        (requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack)
        ">
      <div class="page-actions">
        <button class="btn btn-success" (click)="showCreateModal()"><i class="fa fa-plus mr-1"></i>
          {{ translationManager.getTranslation('Додати новог члана') }}</button>
      </div>
    </div>

    <div class="app-table-panel" app-table>
      <!-- <div class="app-table-used-filters">
        <div class="app-table-used-filters-title">
          <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span>
        </div>
        <div class="app-table-used-filter-items" search-tags>
          <div class="app-table-used-filter-items-no-content" search-tag-no-content>
            <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span>
          </div>
          <div class="app-table-used-filter-item" style="display: none" search-tag-prototype>
            <span><i search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                search-tag-prototype-value></i></span>
            <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
              search-tag-prototype-close>
              <i class="fas fa-times"></i>
            </a>
          </div>
          <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
            order-tag-prototype>
            <span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                order-tag-prototype-value></i></span>
            <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
              order-tag-prototype-close>
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="app-table-filter-panel" filter>
        <div class="app-table-filter-icon">
          <a href="javascript:;" [title]="translationManager.getTranslation('Филтрирај ентитете')" filter-open>
            <i class="fas fa-filter"></i>
          </a>
        </div>
        <div class="app-table-filter">
          <div class="app-table-filter-search">
            <div class="app-table-filter-title">
              <span>{{ translationManager.getTranslation('Филтери') }}</span>
              <a href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер')" filter-close>
                <i class="fas fa-times"></i>
              </a>
            </div>
            <div class="page-part">
              <div class="alert alert-info">
                <span><i
                    class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Доступни филтери за процес филтрирања података') }}</span>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Организациона јединица') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="OrganizationalUnit"
                    [search-title-new]="translationManager.getTranslation('Организациона јединица')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Име и презиме') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="FullName"
                    [search-title-new]="translationManager.getTranslation('Име и презиме')" search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Позиција') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="EmployeePosition"
                    [search-title-new]="translationManager.getTranslation('Позиција')" search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Област оцењивања') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="AssessmentArea"
                    [search-title-new]="translationManager.getTranslation('Област оцењивања')" search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Кадровска област') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="PersonnelArea"
                    [search-title-new]="translationManager.getTranslation('Кадровска област')" search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Дата сагласност') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="IsGivenCompliance"
                    [search-title-new]="translationManager.getTranslation('Дата сагласност')" search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Датум давања сагласности') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="ComplianceDate"
                    [search-title-new]="translationManager.getTranslation('Датум давања сагласности')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="app-form-element-buttons">
              <button class="btn btn-success" do-search><i
                  class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Филтрирај') }}</button>
              <button class="btn btn-danger" reset-search><i
                  class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Поништи') }}</button>
            </div>
          </div>
        </div>
      </div> -->
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">
              <th>
                <!-- <a href="javascript:;"
                  [title]="translationManager.getTranslation('Сортирање по организационој јединици')" order
                  order-entity="OrganizationalUnit">
                  {{ translationManager.getTranslation('Организациона јединица') }}
                </a> -->
                {{ translationManager.getTranslation('Организациона јединица') }}
              </th>
              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по имену члана')" order
                  order-entity="FullName">
                  {{ translationManager.getTranslation('Име и презиме') }}
                </a> -->
                {{ translationManager.getTranslation('Име и презиме') }}
              </th>
              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по позицији')" order
                  order-entity="EmployeePosition">
                  {{ translationManager.getTranslation('Позиција') }}
                </a> -->
                {{ translationManager.getTranslation('Позиција') }}
              </th>
              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по области оцењивања')"
                  order order-entity="AssessmentArea">
                  {{ translationManager.getTranslation('Област оцењивања') }}
                </a> -->
                {{ translationManager.getTranslation('Област оцењивања') }}
              </th>
              <th>
                <!-- <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по кадровској области')"
                  order order-entity="PersonnelArea">
                  {{ translationManager.getTranslation('Кадровска област') }}
                </a> -->
                {{ translationManager.getTranslation('Кадровска област') }}
              </th>
              <th>
                <!-- <a href="javascript:;"
                  [title]="translationManager.getTranslation('Сортирање по опцији да ли је дата сагласност')" order
                  order-entity="IsGivenCompliance">
                  {{ translationManager.getTranslation('Дата сагласност') }}
                </a> -->
                {{ translationManager.getTranslation('Дата сагласност') }}
              </th>
              <th>
                <!-- <a href="javascript:;"
                  [title]="translationManager.getTranslation('Сортирање по датуму давања сагласности')" order
                  order-entity="ComplianceDate">
                  {{ translationManager.getTranslation('Датум давања сагласности') }}
                </a> -->
                {{ translationManager.getTranslation('Датум давања сагласности') }}
              </th>
              <th style="width: 140px" class="right" *ngIf="state === viewState.Edit">
                {{ translationManager.getTranslation('Акције') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>{{item.organizationalUnit}}</td>
              <td>{{item.fullName}}</td>
              <td>{{item.employeePosition}}</td>

              <td>
                <span [ngStyle]="{'color': item.assessmentArea===null ? 'red' : '' }">
                  {{item.assessmentArea===null? translationManager.getTranslation('Поље је обавезно за унос'):item.assessmentArea}}
                </span>
              </td>

              <td>{{item.personnelArea}}</td>
              <td>{{item.isGivenCompliance == true ?
                translationManager.getTranslation('Да') : item.isGivenCompliance == false ?
                translationManager.getTranslation('Не') : '-'}}</td>
              <td>{{item.complianceDate | appdate | appvalue}}</td>
              <td class="right" *ngIf="state === viewState.Edit">
                <div class="table-actions">
                  <a *ngIf="auth.isAuthorized('F6DD18CB-A195-4107-BE7E-CADE04DC7E3D') && item.assessmentArea == null"
                    (click)="showEditModal(item)" href="javascript:;"
                    [title]="translationManager.getTranslation('Измена')">
                    <i class="far fa-file-alt"></i>
                  </a>
                  <a *ngIf="requestStatus == requestStatusUniqueIdentifier.inProgress || requestStatus == requestStatusUniqueIdentifier.changesBack
                      && auth.isAuthorized('48E03E02-8BB1-4263-AD4E-3D15FF9AC9ED')"
                    (click)="showDeleteModalFor(item.id)" href="javascript:;" class="red"
                    [title]="translationManager.getTranslation('Брисање')">
                    <i class="far fa-trash-alt"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>

      <!-- <div class="form-element-buttons">
        <button class="btn btn-warning fl" (click)="navigateToList()">
          <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation('Назад') }}</button>
        <button class="btn btn-success fr" (click)="submit()"
          *ngIf="state === viewState.Edit">
          <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Сачувај') }}</button>
      </div> -->

      <!-- <div class="app-table-pagination">
        <div>
          <div pagination>
            <span>{{ translationManager.getTranslation('Страна') }}</span>
            <select pagination-pages>
              <option>1</option>
            </select>
            <span>{{ translationManager.getTranslation('од') }}</span>
            <span pagination-pages-count>-</span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на почетак')"
                pagination-first-page>
                <i class="fas fa-angle-double-left"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Претходна')" pagination-previous-page>
                <i class="fas fa-angle-left"></i>
              </a>
            </span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Следећа')" pagination-next-page>
                <i class="fas fa-angle-right"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page>
                <i class="fas fa-angle-double-right"></i>
              </a>
            </span>
            <span>{{ translationManager.getTranslation('Број редова за приказ') }}</span>
            <select pagination-sizes>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div class="app-table-pagination-sizes">
          <div>
            <span>{{ translationManager.getTranslation('Укупан број слогова') }}</span>
            <span pagination-total-count>-</span>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>
<app-modal [show]="showDeleteModal" (onHide)="closeDeleteModal()"
  [title]="translationManager.getTranslation('Брисање члана?')">
  <div class="app-modal-content">
    {{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете члана?') }}
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()">
      <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="closeDeleteModal()" class="btn btn-warning">
      <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

<opn-team-member #opnTeamMemberComponent></opn-team-member>
